import React from "react";

interface DashboardCardProps {
  children: React.ReactNode;
}

export const DashboardCard = ({ children }: DashboardCardProps) => (
  <div className="bg-gray-50 shadow-lg rounded-2xl p-6 w-full overflow-x-auto flex flex-col gap-6">
    {children}
  </div>
)